import { render } from "./App.vue?vue&type=template&id=c018733a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c018733a&lang=scss"
script.render = render

export default script